const prefix = '@@seat-selection-integration-orm';

const INITIALIZE_HALL = `${prefix}/INITIALIZE_HALL`;
const INITIALIZE_HALL_WITH_SEATS = `${prefix}/INITIALIZE_HALL_WITH_SEATS`;
const SET_SECTORS = `${prefix}/SET_SECTORS`;
const SET_SECTOR_WITH_SEATS = `${prefix}/SET_SECTOR_WITH_SEATS`;
const SET_SEATS_PURCHASE_STATUS = `${prefix}/SET_SEATS_PURCHASE_STATUS`;
const SET_GENERAL_ADMISSIONS_USED_SEATS_COUNT = `${prefix}/SET_GENERAL_ADMISSIONS_USED_SEATS_COUNT`;
const ADJUST_GENERAL_ADMISSIONS_USED_SEATS_COUNT = `${prefix}/ADJUST_GENERAL_ADMISSIONS_USED_SEATS_COUNT`;
const SET_RESERVATION_SEAT_AS_AVAILABLE = `${prefix}/SET_RESERVATION_SEAT_AS_AVAILABLE`;
const DELETE_SEATING_RESERVATION = `${prefix}/DELETE_SEATING_RESERVATION`;
const SET_GENERAL_ADMISSIONS_PURCHASE_STATUS = `${prefix}/SET_GENERAL_ADMISSIONS_PURCHASE_STATUS`;
const COMPILE_OBJECTS_CACHE_KEY = `${prefix}/COMPILE_OBJECTS_CACHE_KEY`;
const DELETE_TICKET_TYPE = `${prefix}/DELETE_TICKET_TYPE`;
const UNASSIGN_TICKET_TYPE_FROM_SEATINGS = `${prefix}/UNASSIGN_TICKET_TYPE_FROM_SEATINGS`;

export {
    INITIALIZE_HALL,
    INITIALIZE_HALL_WITH_SEATS,
    SET_SECTORS,
    SET_SECTOR_WITH_SEATS,
    SET_SEATS_PURCHASE_STATUS,
    SET_GENERAL_ADMISSIONS_USED_SEATS_COUNT,
    ADJUST_GENERAL_ADMISSIONS_USED_SEATS_COUNT,
    SET_RESERVATION_SEAT_AS_AVAILABLE,
    DELETE_SEATING_RESERVATION,
    COMPILE_OBJECTS_CACHE_KEY,
    DELETE_TICKET_TYPE,
    SET_GENERAL_ADMISSIONS_PURCHASE_STATUS,
    UNASSIGN_TICKET_TYPE_FROM_SEATINGS,
};
